import baseAPI from '@/api';
import { RewardId } from '@/enums/reward-id';
import { RewardStatusId } from '@/models/user-reward/reward/status/id';
import { UserRewardTracker } from '@/models/user-reward/tracker';
import { AxiosResponse } from 'axios';

export async function fetchUserRewardsTracker(): Promise<
  Array<UserRewardTracker>
> {
  try {
    const response: AxiosResponse<Array<UserRewardTracker>> = await baseAPI.get<
      Array<UserRewardTracker>
    >('/user-rewards/trackers', {
      params: {
        statusId: RewardStatusId.Active.toString(),
      },
    });

    return response.data.filter(
      reward =>
        ![RewardId.Freebet.toString(), RewardId.Freespin.toString()].includes(
          reward.rewardId?.toString(),
        ),
    );
  } catch (error) {
    return null;
  }
}
